
export const Exclamacion = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} >
        <circle cx={12} cy={12} r={10} fill="red" />
        <path fill="#fff" d="M11 6h2v8h-2zm0 10h2v2h-2z" />
    </svg>
)

